import { ControlledTextField } from '@if/mui'
import { IconButton, InputAdornment } from '@mui/material'
import { Visibility, VisibilityOff, Close as CloseIcon } from '@mui/icons-material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors } from 'react-hook-form'
import { NewSecretsFormData } from '../index'

interface SecretRowProps {
  index: number
  control: Control<NewSecretsFormData>
  errors: FieldErrors<NewSecretsFormData>
  onRemove: () => void
  disabled: boolean
  canRemove: boolean
}

const SecretRow = ({ index, control, errors, onRemove, disabled, canRemove }: SecretRowProps) => {
  const { t } = useTranslation()
  const [showValue, setShowValue] = useState(false)

  const keyError = errors.secrets?.[index]?.key?.message
  const valueError = errors.secrets?.[index]?.value?.message
  const translatedKeyError = keyError ? t(keyError, keyError) : undefined
  const translatedValueError = valueError ? t(valueError, valueError) : undefined

  return (
    <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', marginBottom: 8 }}>
      <ControlledTextField
        name={`secrets.${index}.key`}
        control={control}
        label={t('keyVault.secretKey', 'Secret Key')}
        size="small"
        fullWidth
        disabled={disabled}
        helperText={translatedKeyError}
      />
      <ControlledTextField
        name={`secrets.${index}.value`}
        control={control}
        label={t('keyVault.secretValue', 'Secret Value')}
        size="small"
        fullWidth
        type={showValue ? 'text' : 'password'}
        disabled={disabled}
        helperText={translatedValueError}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => setShowValue(!showValue)} edge="end">
                  {showValue ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
      <IconButton onClick={onRemove} disabled={disabled || !canRemove} color="error" size="small" sx={{ mt: 0.5 }}>
        <CloseIcon />
      </IconButton>
    </div>
  )
}

export default SecretRow
